import {createRouter, createWebHashHistory} from 'vue-router'
import DummyRouterView from "./components/DummyRouterView";

const routes = [
    {name: 'mgt', path: '/', component: DummyRouterView},
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

const getParams = () => {
    const query = Object.fromEntries(new URLSearchParams(window.location.hash.replace('#/?', '')));


    const params = {
        facets: {},
        query: '',
    };

    for (const q in query) {
        if (q === 'mgt-query') {
            params.query = query[q];
            continue;
        }

        const group = q.match(/mgt-filters\[([^\]]+)/);

        if (!group || !group[1]) {
            continue;
        }

        params.facets[group[1]] = query[q].split('!,');
    }

    return params;
}

router.beforeEach((to, from, next) => {
    next();
})


export {router, routes}
